export interface IRouteDirection {
  route: string;
  direction: string;
  cssClass: 'arrow-zone-down' | 'arrow-zone-up' |
    'arrow-zone-left' | 'arrow-zone-right' | 'arrow-zone-down light' |
    'arrow-zone-up light' | 'arrow-zone-left light' | 'arrow-zone-right light';
}

export class RouteDirections {
  public home: IRouteDirection[] = [
    {route: '/work', direction: 'downward', cssClass: 'arrow-zone-down'},
    {route: '/contact', direction: 'upward', cssClass: 'arrow-zone-up'},
  //  {route: '/contact', direction: 'backward', cssClass: 'arrow-zone-left'},
  //  {route: '/work', direction: 'forward', cssClass: 'arrow-zone-right'}
  ];

  public work: IRouteDirection[] = [
    {route: '/education', direction: 'downward', cssClass: 'arrow-zone-down'},
    {route: '/home', direction: 'upward', cssClass: 'arrow-zone-up'},
  //  {route: '/home', direction: 'backward', cssClass: 'arrow-zone-left'},
    {route: '/work/disciple', direction: 'forward', cssClass: 'arrow-zone-right'}
  ];

  public deepcrawl: IRouteDirection[] = [
    {route: '/education', direction: 'downward', cssClass: 'arrow-zone-down'},
    {route: '/home', direction: 'upward', cssClass: 'arrow-zone-up'},
    {route: '/work/disciple', direction: 'backward', cssClass: 'arrow-zone-left'},
    {route: '/work/infringement-report', direction: 'forward', cssClass: 'arrow-zone-right'}
  ];

  public disciple: IRouteDirection[] = [
    {route: '/education', direction: 'downward', cssClass: 'arrow-zone-down'},
    {route: '/home', direction: 'upward', cssClass: 'arrow-zone-up'},
    {route: '/work', direction: 'backward', cssClass: 'arrow-zone-left'},
    {route: '/work/deepcrawl', direction: 'forward', cssClass: 'arrow-zone-right'}
  ];

  public infringementreport: IRouteDirection[] = [
    {route: '/education', direction: 'downward', cssClass: 'arrow-zone-down'},
    {route: '/home', direction: 'upward', cssClass: 'arrow-zone-up'},
    {route: '/work/deepcrawl', direction: 'backward', cssClass: 'arrow-zone-left'},
    {route: '/work/allotment-digital', direction: 'forward', cssClass: 'arrow-zone-right'}
  ];

  public allotmentdigital: IRouteDirection[] = [
    {route: '/education', direction: 'downward', cssClass: 'arrow-zone-down'},
    {route: '/home', direction: 'upward', cssClass: 'arrow-zone-up'},
    {route: '/work/infringement-report', direction: 'backward', cssClass: 'arrow-zone-left'},
    {route: '/work/vinna', direction: 'forward', cssClass: 'arrow-zone-right'}
  ];

  public vinna: IRouteDirection[] = [
    {route: '/education', direction: 'downward', cssClass: 'arrow-zone-down'},
    {route: '/home', direction: 'upward', cssClass: 'arrow-zone-up'},
    {route: '/work/allotment-digital', direction: 'backward', cssClass: 'arrow-zone-left'},
    {route: '/education', direction: 'forward', cssClass: 'arrow-zone-right'}
  ];

  public education: IRouteDirection[] = [
    {route: '/contact', direction: 'downward', cssClass: 'arrow-zone-down light'},
    {route: '/work', direction: 'upward', cssClass: 'arrow-zone-up light'},
    //{route: '/work', direction: 'backward', cssClass: 'arrow-zone-left light'},
    //{route: '/results', direction: 'forward', cssClass: 'arrow-zone-right light'}
  ];

  public results: IRouteDirection[] = [
    {route: '/contact', direction: 'downward', cssClass: 'arrow-zone-down'},
    {route: '/education', direction: 'upward', cssClass: 'arrow-zone-up'},
  //  {route: '/education', direction: 'backward', cssClass: 'arrow-zone-left'},
    {route: '/results/regus', direction: 'forward', cssClass: 'arrow-zone-right'}
  ];

  public regus: IRouteDirection[] = [
    {route: '/speaking', direction: 'downward', cssClass: 'arrow-zone-down'},
    {route: '/education', direction: 'upward', cssClass: 'arrow-zone-up'},
    {route: '/results/image-raider', direction: 'backward', cssClass: 'arrow-zone-left'},
    {route: '/results/the-space', direction: 'forward', cssClass: 'arrow-zone-right'}
  ];

  public theSpace: IRouteDirection[] = [
    {route: '/contact', direction: 'downward', cssClass: 'arrow-zone-down'},
    {route: '/education', direction: 'upward', cssClass: 'arrow-zone-up'},
    {route: '/results/regus', direction: 'backward', cssClass: 'arrow-zone-left'},
    {route: '/contact', direction: 'forward', cssClass: 'arrow-zone-right'}
  ];

  public speaking: IRouteDirection[] = [
    {route: '/contact', direction: 'downward', cssClass: 'arrow-zone-down light'},
    {route: '/results', direction: 'upward', cssClass: 'arrow-zone-up light'},
   // {route: '/results', direction: 'backward', cssClass: 'arrow-zone-left light'},
   // {route: '/contact', direction: 'forward', cssClass: 'arrow-zone-right light'}
  ];

  public contact: IRouteDirection[] = [
    {route: '/home', direction: 'downward', cssClass: 'arrow-zone-down light'},
    {route: '/education', direction: 'upward', cssClass: 'arrow-zone-up light'},
  //  {route: '/speaking', direction: 'backward', cssClass: 'arrow-zone-left light'},
  //  {route: '/home', direction: 'forward', cssClass: 'arrow-zone-right light'}
  ];
}




// WEBPACK FOOTER //
// /opt/buildhome/repo/src/app/_animations/route-directions.constant.ts